// extracted by mini-css-extract-plugin
module.exports = {"store_btn":"store_store_btn__2Gvye","btn__1":"store_btn__1__2Z62a"};